import { useState } from 'react';

interface UseGroupCreationOptions {
  createGroupConversation: (
    name: string,
    userIds: number[],
  ) => Promise<{ id: number }>;
  fetchConversations: () => Promise<void>;
  onSuccess: (conversationId: number) => void;
}

export function useGroupCreation({
  createGroupConversation,
  fetchConversations,
  onSuccess,
}: UseGroupCreationOptions) {
  const [selectedUsersForGroup, setSelectedUsersForGroup] = useState<number[]>(
    [],
  );
  const [newGroupName, setNewGroupName] = useState('');
  const [creatingGroup, setCreatingGroup] = useState(false);

  const toggleUserSelection = (userId: number) => {
    setSelectedUsersForGroup((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId],
    );
  };

  const resetForm = () => {
    setSelectedUsersForGroup([]);
    setNewGroupName('');
  };

  const handleCreateGroup = async () => {
    if (!newGroupName.trim() || selectedUsersForGroup.length === 0) return;
    setCreatingGroup(true);
    try {
      const conv = await createGroupConversation(
        newGroupName,
        selectedUsersForGroup,
      );
      await fetchConversations();
      onSuccess(conv.id);
      resetForm();
    } catch (err) {
      console.error('Erro ao criar grupo', err);
    } finally {
      setCreatingGroup(false);
    }
  };

  return {
    selectedUsersForGroup,
    newGroupName,
    setNewGroupName,
    creatingGroup,
    toggleUserSelection,
    resetForm,
    handleCreateGroup,
  };
}
